module.exports = __webpack_public_path__ + "static/media/speech_06.073aa49d.png";